import React, { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getAbbyySkill, setAbbySkill } from "api";
import { useNotify } from "hooks";
import { COLORS, SettingButtonText } from "components";

export const ABBYYSkills = ({ isAdminUser = false }: { isAdminUser: boolean }) => {
  const notify = useNotify();

  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  const { data: abbyySkill, refetch } = useQuery(["abbyySkill"], getAbbyySkill, { enabled: isAdminUser });
  const { mutateAsync: updateAbbyySkills } = useMutation(setAbbySkill);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setInputValue(value);
    setError(value.trim() === "" ? "This field is required." : "");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (inputValue.trim() === "") {
      setError("This field is required.");
      return;
    }

    try {
      await updateAbbyySkills(inputValue);
      notify.success("Successfully updated Abbyy Skills!");
      refetch();
    } catch (err) {
      notify.error("Some error has happened while updating Abbyy Skills");
    }
  };

  useEffect(() => {
    if (abbyySkill?.data?.message) {
      setInputValue(abbyySkill.data.message);
    }
  }, [abbyySkill]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        my: 2,
      }}
    >
      <Box>
        <TextField
          label=""
          variant="standard"
          value={inputValue}
          onChange={handleInputChange}
          error={!!error}
          helperText={error}
          sx={{
            width: "240px",
            height: "32px",
            "& .MuiInputBase-input": {
              color: COLORS.Romance,
              fontSize: "16px",
              fontWeight: "600",
              padding: "0px",
              letterSpacing: "0.5px",
              fontFamily: "Inter",
            },
          }}
        />
      </Box>
      <Box>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            color: "white",
            backgroundColor: COLORS.Romance,
            width: "240px",
            height: "36px",
            borderRadius: "8px",
          }}
        >
          <SettingButtonText>Apply</SettingButtonText>
        </Button>
      </Box>
    </Box>
  );
};
